import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const ROLE_TYPES = ["REQUESTER", "L1", "L2", "OTHER"] as const;
export type RoleType = typeof ROLE_TYPES[number];

interface UserRole {
  role_type: RoleType;
}

const initialState: UserRole = {
  role_type: "REQUESTER",
};

export const userRoleSlice = createSlice({
  name: "userRole",
  initialState,
  reducers: {
    setUserRole: (state, action: PayloadAction<RoleType>) => {
      state.role_type = action.payload;
    },
  },
});

export const { setUserRole } = userRoleSlice.actions;

export const selectRoleType = (state: RootState) => state.userRole.role_type;

export default userRoleSlice.reducer;
